export const ERROR_STATUS_CODE = {
  ERROR_LINK: 6000,
  INVALID_ACCESS_TOKEN: 2000,
  INVALID_REFRESH_TOKEN: 2001,
  USER_NOT_FOUND: 2003,
  INVALID_CREDENTIAL: 1000,
};
